import { useNavigate } from "react-router";
import { NavigationBar } from "../../../components/navigation/NavigationBar";
import { DISCOVER, DISCOVER_SEARCH } from "../../../constants/routes";
import { useDiscoveryProductBestsellersGroup } from "../../../hooks/api/v2/discovery/useDiscoveryProductBestsellersGroup";
import { DiscoverySubPageListsView } from "./components/DiscoverySubPageListsView";
import { useDiscoveryV2SearchStore } from "./DiscoveryV2SearchStore";

export const DiscoveryV2BestSellersList = () => {
  const navigate = useNavigate();
  const setOrderBy = useDiscoveryV2SearchStore((state) => state.setOrderBy);
  const discoveryBestSellersQuery = useDiscoveryProductBestsellersGroup({
    limit: 20,
  });

  const redirectDiscover = () => {
    setOrderBy("bestsellers");
    navigate(DISCOVER_SEARCH);
  };

  return (
    <>
      <NavigationBar
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => {
          navigate(DISCOVER);
        }}
        title={"Bestsellers"}
      />
      <DiscoverySubPageListsView
        query={discoveryBestSellersQuery}
        onRedirect={redirectDiscover}
      />
    </>
  );
};
